// L'ATTRIBUTION — « de QUI ? », et la SEULE rédaction de la règle du badge.
//
// Le 25/08/2026, la fiche de Yannick Labaune — archéologue VIVANT du Service
// archéologique de la Ville d'Autun — portait le badge « ATTRIBUTION
// DÉBATTUE ». Sa fiche dit pourtant « attesté (fonctions et publications,
// d'après le SAVA, l'Inrap et des revues à comité de lecture) ». L'écran
// testait `confidence !== 'attesté'` : une égalité stricte contre un champ qui
// porte de la PROSE, donc le qualificatif entre parenthèses suffisait à faire
// basculer la fiche. 18 personnages sur 45 étaient ainsi badgés à tort, dont
// dix chercheurs contemporains ou vivants. Mettre un doute sur le nom de qui a
// trouvé est une faute de Loi 2 — la plus grave que cet écran puisse commettre.
//
// La même idée existait alors en TROIS rédactions divergentes : l'égalité
// stricte des personnages (opt-out), `/débattu/i` sur les trésors (opt-in), et
// une expression régulière jumelle côté serveur pour la frise. Trois copies
// d'une règle divergent toujours ; celle-ci n'existe plus qu'ici.
//
// LA RÈGLE, en une phrase : le badge ne s'allume que sur une DÉCLARATION
// explicite de la fiche (`attribution: debattue`, vocabulaire fermé validé au
// chargement — backend/content_loader.ATTRIBUTIONS), servie par l'API comme le
// booléen `attribution_debattue`. Aucune prose n'est reniflée nulle part : une
// expression régulière plus fine ne corrigerait pas le défaut, elle le
// déplacerait.
//
// ⚠ NE PAS CONFONDRE avec `certitude` (frise), qui doute de la DATE.
// `gislebertus` porte `certitude: attestee` (ses dates sont sûres) ET
// l'attribution débattue (on ne sait pas qui il était) ; `pectorios` porte
// l'inverse exact. Un seul badge pour les deux dirait à l'invité qu'on ne sait
// rien, alors qu'on sait précisément quoi.

/**
 * L'attribution de cette fiche est-elle débattue ? Le canon doute de QUI —
 * l'auteur d'une œuvre, l'identité d'une figure — et jamais de QUAND.
 *
 * Vrai UNIQUEMENT sur le booléen déclaré : `undefined`, une chaîne, ou un
 * `confidence` bavard ne l'allument pas.
 */
export const isAttributionDebattue = (fiche) => fiche?.attribution_debattue === true;

export default isAttributionDebattue;
